import _uniqueId from 'lodash/uniqueId';
import IndexTableRowRenderer from '../index-table/IndexTableRowRenderer'
import ConfigTag from './../configurations/ConfigurationsTag';
import SetProductSerialNumberModal from './modals/SetProductSerialNumberModal';
import SetProductSerialNumberModalForNew from './modals/SetProductSerialNumberForNewModal';
import ProjectStore from '../../store/projectStore';
import WarningsContainer from '../../components/common/WarningsContainer';
import RequiredProjectSaveModal from './modals/RequiredProjectSaveModal';
import Assets from '@lib/Assets'
import Button from '@lib/components/common/Button'
import IconAccept from '@lib/components/icons/IconAccept';

export default class ProjectConfigurationsIndexTableRowRenderer extends IndexTableRowRenderer {

    state = {
        discountRef: null
    }

    constructor(props, indexTableRow) {
        super(props, indexTableRow);
        this.renderNameColumn = this.renderNameColumn.bind(this);
    }

    renderCapacitiesColumn(column, value) {
        return (
            <td style={{whiteSpace: 'nowrap'}}>
                {value}
            </td>
        )
    }

    renderStatusColumn(column, value) {
        return (
            <td>
                {ConfigTag.get(value)}
            </td>
        );
    }

    renderHeatExchangersColumn(column, value) {
        return (
            <td>
                <ul>
                    {value.map(v => <li>{v}</li>)}
                </ul>
            </td>
        )
    }

    renderLastEditColumn(column, value) {
        return (
            <td>
                <div>{value.item1}</div>
                <div>{value.item2}</div>
            </td>
        )
    }

    renderNameColumn(column, value) {
        const renderWithoutLink = (onClick = () => {
        }) => {
            return <td className="index-name-column" key={column.slug}><span><a href="#" style={{color: '#9da4b3'}}
                                                                                onClick={onClick}>{value}</a></span>
            </td>
        }
        if (ProjectStore.isNew()) {
            return (<React.Fragment>
                {this.renderRequiredProjectSaveModal()}
                {renderWithoutLink((e) => this.showRequiredProjectSaveModal(e))}
            </React.Fragment>)
        }

        if (this.props.row.isNew) {
            return (<React.Fragment>
                {this.renderRequiredProjectSaveModal()}
                {renderWithoutLink((e) => this.showRequiredProjectSaveModal(e))}
            </React.Fragment>)
        }

        if (!this.props.row.canView) {
            return renderWithoutLink();
        }
        const warnings = [
            this.props.row.replacedInDocumentGeneratorWarning,
            this.props.row.anyRemovedComponentWarning,
            this.props.row.anyManuallyAddedComponentWarning
        ].filter(x => x).map(x => ({...x, text: __(x.text)}))
        return super.renderNameColumn(column, value,
            <div>
                {this.renderNumber()}
                {this.renderProductSerialNumber()}
                <div style={{display: 'flex', marginTop: '5px'}}>
                    <WarningsContainer warning={warnings}/>
                </div>
                {(this.props.canSetConfigurationOptional && this.props.row.optionGroupGuid && this.props.row.optionState === 0) &&
                    <Button className="project-configrations-versions-button" theme={Button.Theme.BorderOnly}
                            onClick={this.onOptionSelectClick}>{__('Select')}</Button>}
                {(this.props.canSetConfigurationOptional && this.props.row.optionGroupGuid && this.props.row.optionState === 1) &&
                    <Button className="project-configrations-versions-button --preferred"
                            theme={Button.Theme.BorderOnly} onClick={this.onOptionSelectClick}>{__('Preferred')}
                        <br/> {__('Please click to confirm')}</Button>}
                {(this.props.canSetConfigurationOptional && this.props.row.optionGroupGuid && this.props.row.optionState === 2) &&
                    <Button className="project-configrations-versions-button --selected" icon={IconAccept}
                            theme={Button.Theme.BorderOnly}>{__('Selected')}</Button>}
            </div>);
    }

    onOptionSelectClick = () => {
        this.props.onOptionSelectClick(this.props.row);
    }

    renderNumber = () => {
        return (
            <span className="name-sub-title">
                {this.props.row.number}
            </span>
        )
    }

    renderProductSerialNumber = () => {
        if (!this.props.row.canSetProductSerialNumber) {
            return <React.Fragment/>
        }

        const productSerialNumber = this.props.row.productSerialNumber;
        if (ProjectStore.manuallyAddedConfigurations.includes(this.props.row.guid)) {
            const classes = ['configuration-product-serial-number'];
            var label = `${__('S/N')}: ${productSerialNumber}`;

            if (!productSerialNumber) {
                classes.push('--missing');
                label = __('S/N: not available')
            }

            return (
                <React.Fragment>
                    {this.renderSetProductSerialNumberForNewModal()}
                    <span onClick={() => this.onProductSerialNumberClick()} className={classes.join(' ')}>{label}</span>
                </React.Fragment>
            )
        }

        if (productSerialNumber) {
            return (
                <React.Fragment>
                    {this.renderSetProductSerialNumberModal()}
                    <span onClick={() => this.onProductSerialNumberClick()}
                          className="configuration-product-serial-number">{__('S/N')}: {productSerialNumber}</span>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    {this.renderSetProductSerialNumberModal()}
                    <span onClick={() => this.onProductSerialNumberClick()}
                          className="configuration-product-serial-number --missing">{__('S/N: not available')}</span>
                </React.Fragment>
            )
        }
    }

    renderRequiredProjectSaveModal = () => (
        <RequiredProjectSaveModal
            visible={this.indexTableRow.state.requiredProjectSaveModal}
            onClose={() => this.closeRequiredProjectSaveModal()}
        />
    )

    renderSetProductSerialNumberModal = () => (
        <SetProductSerialNumberModal
            productSerialNumber={this.props.row.productSerialNumber}
            projectId={this.props.projectId}
            configurationId={this.props.row.id}
            onClose={() => this.onProductSerialNumberCloseClick()}
            onSuccess={this.onProductSerialNumberChanged}
            visible={this.indexTableRow.state.setProductSerialNumberModal}
        />
    )

    renderSetProductSerialNumberForNewModal = () => (
        <SetProductSerialNumberModalForNew
            productSerialNumber={this.props.row.productSerialNumber}
            onClose={() => this.onProductSerialNumberCloseClick()}
            onSuccess={this.onProductSerialNumberChanged}
            visible={this.indexTableRow.state.setProductSerialNumberModal}
        />
    )

    onProductSerialNumberClick = () => {
        this.indexTableRow.setState({setProductSerialNumberModal: true});
    }

    onProductSerialNumberCloseClick = () => {
        this.indexTableRow.setState({setProductSerialNumberModal: false});
    }

    showRequiredProjectSaveModal = (e) => {
        e.preventDefault();
        this.indexTableRow.setState({requiredProjectSaveModal: true});
    }

    closeRequiredProjectSaveModal = () => {
        this.indexTableRow.setState({requiredProjectSaveModal: false});
    }

    onProductSerialNumberChanged = response => {
        this.props.onProductSerialNumberChanged(this.props.row, response);
        this.onProductSerialNumberCloseClick();
    }


    renderCopyButtonAction = (button, row) => {
        if (row.isNew) {
            return (
                <React.Fragment/>
            )
        }

        return (
            <a key={button.slug} className="index-action-button"
               onClick={() => this.indexTableRow.props.onCopyRowClick(this.props.row.guid)}>
                <img src={Assets[button.icon]}/>
            </a>
        )
    }
}